<template>
  <div class="settings-container">
    <!-- 背景层 -->
    <div class="background-layer">
      <img src="@/assets/img/img23.png" class="bg-img" />
      <div class="bg-overlay"></div>
    </div>

    <!-- 内容层 -->
    <div class="content-layer">
      <!-- 顶部标题栏 -->
      <div class="settings-header">
        <div class="header-back" @click="goBack">
          <i class="el-icon-arrow-left"></i>
        </div>
        <div class="header-title">设置</div>
        <div class="header-placeholder"></div>
      </div>

      <!-- 用户信息卡片 -->
      <div class="user-card">
        <div class="user-avatar">
          <img :src="avatar" class="avatar-img" />
          <!-- <div class="avatar-edit" @click="showAvatarEdit = true">
            <i class="el-icon-camera"></i>
          </div> -->
        </div>
        <div class="user-info">
          <div class="user-name">{{ userName }}</div>
          <!-- <div class="user-id">ID: {{ userId }}</div> -->
        </div>
      </div>

      <!-- 设置选项 -->
      <div class="settings-list">
        <!-- 修改昵称 -->
        <div class="settings-item" @click="showEditNickname = true">
          <div class="item-left">
            <i class="el-icon-user item-icon"></i>
            <span class="item-text">修改昵称</span>
          </div>
          <div class="item-right">
            <span class="item-value">{{ userName }}</span>
            <i class="el-icon-arrow-right"></i>
          </div>
        </div>

        <!-- 修改密码 -->
        <div class="settings-item" @click="showEditPassword = true">
          <div class="item-left">
            <i class="el-icon-lock item-icon"></i>
            <span class="item-text">修改密码</span>
          </div>
          <div class="item-right">
            <i class="el-icon-arrow-right"></i>
          </div>
        </div>

        <!-- 退出登录 -->
        <div class="logout-item" @click="handleLogout">
          <i class="el-icon-switch-button logout-icon"></i>
          <span class="logout-text">退出登录</span>
        </div>
      </div>
    </div>

    <!-- 修改昵称弹窗 -->
    <el-dialog
      title="修改昵称"
      :visible.sync="showEditNickname"
      width="85%"
      custom-class="custom-dialog"
      :close-on-click-modal="false"
    >
      <div class="dialog-content">
        <el-input
          v-model="nicknameForm.nickName"
          placeholder="请输入新昵称"
          maxlength="20"
          show-word-limit
        ></el-input>
        <div class="dialog-tips">昵称长度为2-20个字符</div>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="showEditNickname = false">取消</el-button>
        <el-button
          type="primary"
          @click="saveNickname"
          :disabled="!nicknameForm.nickName || nicknameForm.nickName.length < 2"
        >
          保存
        </el-button>
      </span>
    </el-dialog>

    <!-- 修改密码弹窗 -->
    <el-dialog
      title="修改密码"
      :visible.sync="showEditPassword"
      width="85%"
      custom-class="custom-dialog"
      :close-on-click-modal="false"
    >
      <div class="dialog-content">
        <el-form
          :model="passwordForm"
          :rules="passwordRules"
          ref="passwordFormRef"
          label-width="80px"
          class="password-form"
        >
          <el-form-item label="原密码" prop="oldPassword">
            <el-input
              v-model="passwordForm.oldPassword"
              type="password"
              placeholder="请输入原密码"
              show-password
            ></el-input>
          </el-form-item>
          <el-form-item label="新密码" prop="newPassword">
            <el-input
              v-model="passwordForm.newPassword"
              type="password"
              placeholder="请输入新密码"
              show-password
            ></el-input>
          </el-form-item>
          <el-form-item label="确认密码" prop="confirmPassword">
            <el-input
              v-model="passwordForm.confirmPassword"
              type="password"
              placeholder="请确认新密码"
              show-password
            ></el-input>
          </el-form-item>
        </el-form>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="showEditPassword = false">取消</el-button>
        <el-button type="primary" @click="savePassword" :loading="isLoading">
          保存
        </el-button>
      </span>
    </el-dialog>

    <!-- 消息提示 -->
    <message :title="messageTitle" ref="messageRef"></message>
  </div>
</template>
<script>
import {
  logout,
  updateUserPwd,
  updateUserProfile,
  getInfo,
} from "@/http/index";
import { setToken, removeToken } from "@/utils/auth";
import message from "@/components/message.vue";

export default {
  name: "Settings",
  components: { message },
  data() {
    const validateConfirmPassword = (rule, value, callback) => {
      if (value !== this.passwordForm.newPassword) {
        callback(new Error("两次输入的密码不一致"));
      } else {
        callback();
      }
    };

    return {
      userName: "",
      userId: "",
      avatar: "",
      showEditNickname: false,
      showEditPassword: false,
      isLoading: false,
      messageTitle: "",

      nicknameForm: {
        nickName: "",
      },

      passwordForm: {
        oldPassword: "",
        newPassword: "",
        confirmPassword: "",
      },

      passwordRules: {
        oldPassword: [
          { required: true, message: "请输入原密码", trigger: "blur" },
          { min: 6, message: "密码长度至少6位", trigger: "blur" },
        ],
        newPassword: [
          { required: true, message: "请输入新密码", trigger: "blur" },
          { min: 6, message: "密码长度至少6位", trigger: "blur" },
        ],
        confirmPassword: [
          { required: true, message: "请确认新密码", trigger: "blur" },
          { validator: validateConfirmPassword, trigger: "blur" },
        ],
      },
    };
  },

  created() {
    this.loadUserInfo();
  },
  methods: {
    getInfo() {
      getInfo().then((res) => {
        if (res.code == 200) {
          localStorage.setItem("userInfo", JSON.stringify(res.data.user));
        }
      });
    },
    loadUserInfo() {
      const userInfo = JSON.parse(localStorage.getItem("userInfo") || "{}");
      this.userName = userInfo.nickName || "用户";
      this.userId = userInfo.userId || "000000";
      this.avatar = userInfo.avatar || require("@/assets/img/img24.png");
      this.nicknameForm.nickName = this.userName;
    },
    goBack() {
      this.$router.back();
    },
    showMessage(msg) {
      this.messageTitle = msg;
      this.$refs.messageRef.show();
    },
    // 保存昵称
    saveNickname() {
      if (
        !this.nicknameForm.nickName ||
        this.nicknameForm.nickName.length < 2
      ) {
        this.showMessage("昵称长度至少2个字符");
        return;
      }

      try {
        updateUserProfile(this.nicknameForm).then((res) => {
          if (res.code == 200) {
            this.$message.success("修改成功");
            this.getInfo();
          }
        });

        this.userName = this.nicknameForm.nickName;
        this.showEditNickname = false;
      } catch (error) {
        this.showMessage("保存失败，请重试");
      }
    },
    // 保存密码
    savePassword() {
      this.$refs.passwordFormRef.validate(async (valid) => {
        if (!valid) return;
        this.isLoading = true;
        try {
          updateUserPwd(
            this.passwordForm.oldPassword,
            this.passwordForm.newPassword,
          ).then((res) => {
            if (res.code == 200) {
              this.$message.success("修改成功");
              this.getInfo();
            } else {
              this.$message.error(res.msg);
            }
          });
          // 清空表单
          this.passwordForm = {
            oldPassword: "",
            newPassword: "",
            confirmPassword: "",
          };
          this.showEditPassword = false;
        } catch (error) {
          this.$message.success("修改失败，请检查原密码是否正确");
        } finally {
          this.isLoading = false;
        }
      });
    },
    // 退出登录
    handleLogout() {
      logout().then((res) => {
        // 清除登录状态
        removeToken();
        localStorage.removeItem("userInfo");

        // 跳转到登录页
        this.$router.replace("/login");

        this.showMessage("已退出登录");
      });

      // this.$confirm("确定要退出登录吗？", "提示", {
      //   confirmButtonText: "确定",
      //   cancelButtonText: "取消",
      //   type: "warning",
      //   customClass: "logout-confirm",
      // })
      //   .then(() => {

      //   })
      //   .catch(() => {
      //     // 用户取消
      //   });
    },
  },
};
</script>

<style lang="scss" scoped>
.settings-container {
  position: relative;
  min-height: 100vh;
  overflow-x: hidden;
}

/* 背景层 */
.background-layer {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  z-index: 1;

  .bg-img {
    width: 100%;
    height: 100%;
    object-fit: cover;
  }

  .bg-overlay {
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background: linear-gradient(
      to bottom,
      rgba(255, 255, 255, 0.1) 0%,
      rgba(255, 255, 255, 0.95) 60%
    );
  }
}

/* 内容层 */
.content-layer {
  position: relative;
  z-index: 2;
  padding: 20px;
  padding-top: 60px;
}

/* 顶部标题栏 */
.settings-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 30px;
  animation: slideDown 0.6s ease-out;

  .header-back {
    width: 40px;
    height: 40px;
    display: flex;
    align-items: center;
    justify-content: center;
    border-radius: 50%;
    background: white;
    box-shadow: 0 4px 12px rgba(102, 25, 17, 0.1);
    cursor: pointer;
    transition: all 0.3s ease;

    i {
      font-size: 20px;
      color: #ff813d;
    }

    &:hover {
      transform: translateX(-2px);
      box-shadow: 0 6px 16px rgba(102, 25, 17, 0.15);

      i {
        color: #ff6a1a;
      }
    }

    &:active {
      transform: translateX(-2px) scale(0.95);
    }
  }

  .header-title {
    font-size: 20px;
    font-weight: 700;
    color: #303133;
    text-shadow: 0 2px 4px rgba(0, 0, 0, 0.05);
  }

  .header-placeholder {
    width: 40px;
  }
}

/* 用户信息卡片 */
.user-card {
  background: white;
  margin-bottom: 20px;
  border-radius: 20px;
  padding: 30px 20px;
  display: flex;
  align-items: center;
  box-shadow: 0 8px 25px rgba(102, 25, 17, 0.08);
  animation: slideUp 0.6s ease-out 0.1s both;
  border: 1px solid transparent;
  transition: all 0.3s ease;

  &:hover {
    border-color: rgba(255, 129, 61, 0.2);
    box-shadow: 0 12px 30px rgba(102, 25, 17, 0.12);
  }

  .user-avatar {
    position: relative;
    margin-right: 20px;

    .avatar-img {
      width: 80px;
      height: 80px;
      border-radius: 50%;
      border: 3px solid rgba(255, 129, 61, 0.8);
      box-shadow: 0 8px 20px rgba(255, 129, 61, 0.25);
    }

    .avatar-edit {
      position: absolute;
      bottom: 0;
      right: 0;
      width: 28px;
      height: 28px;
      background: #ff813d;
      border-radius: 50%;
      display: flex;
      align-items: center;
      justify-content: center;
      color: white;
      cursor: pointer;
      transition: all 0.3s ease;

      i {
        font-size: 14px;
      }

      &:hover {
        background: #ff6a1a;
        transform: scale(1.1);
      }
    }
  }

  .user-info {
    flex: 1;

    .user-name {
      font-size: 22px;
      font-weight: 700;
      color: #303133;
      margin-bottom: 5px;
    }

    .user-id {
      font-size: 14px;
      color: #666;
      opacity: 0.8;
    }
  }
}

/* 设置列表 */
.settings-list {
  animation: slideUp 0.6s ease-out 0.2s both;
}

.settings-item {
  background: white;
  margin-bottom: 12px;
  border-radius: 16px;
  padding: 18px 20px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  cursor: pointer;
  transition: all 0.3s cubic-bezier(0.175, 0.885, 0.32, 1.275);
  box-shadow: 0 6px 20px rgba(102, 25, 17, 0.08);
  border: 1px solid transparent;
  position: relative;

  &::before {
    content: "";
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    height: 3px;
    background: linear-gradient(90deg, #ff813d, #ffb347);
    opacity: 0;
    transition: opacity 0.3s ease;
  }

  &:hover {
    transform: translateX(5px) translateY(-2px);
    box-shadow: 0 12px 30px rgba(102, 25, 17, 0.15);
    border-color: rgba(255, 129, 61, 0.2);

    &::before {
      opacity: 1;
    }

    .item-left .item-icon {
      transform: scale(1.1);
    }

    .item-right i {
      transform: translateX(3px);
    }
  }

  &:active {
    transform: translateX(5px) translateY(-1px) scale(0.98);
  }

  .item-left {
    display: flex;
    align-items: center;

    .item-icon {
      font-size: 22px;
      color: #ff813d;
      margin-right: 15px;
      transition: transform 0.3s ease;
    }

    .item-text {
      font-size: 16px;
      font-weight: 500;
      color: #303133;
    }
  }

  .item-right {
    display: flex;
    align-items: center;

    .item-value {
      font-size: 14px;
      color: #909399;
      margin-right: 10px;
    }

    .version-text {
      font-size: 14px;
      color: #909399;
      margin-right: 10px;
    }

    i {
      font-size: 14px;
      color: #ff813d;
      transition: transform 0.3s ease;
    }
  }
}

/* 退出登录按钮 */
.logout-item {
  background: white;
  margin-top: 20px;
  border-radius: 16px;
  padding: 18px 20px;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  transition: all 0.3s cubic-bezier(0.175, 0.885, 0.32, 1.275);
  box-shadow: 0 6px 20px rgba(102, 25, 17, 0.08);
  border: 1px solid transparent;
  animation: slideUp 0.6s ease-out 0.3s both;

  &:hover {
    background: linear-gradient(135deg, #ff4757, #ff6b6b);
    transform: translateY(-2px);
    box-shadow: 0 12px 30px rgba(255, 71, 87, 0.2);
    border-color: rgba(255, 71, 87, 0.2);

    .logout-icon,
    .logout-text {
      color: white;
    }
  }

  &:active {
    transform: translateY(-1px) scale(0.98);
  }

  .logout-icon {
    font-size: 20px;
    color: #ff4757;
    margin-right: 10px;
    transition: color 0.3s ease;
  }

  .logout-text {
    font-size: 16px;
    font-weight: 500;
    color: #ff4757;
    transition: color 0.3s ease;
  }
}

/* 弹窗样式 */
.dialog-content {
  .dialog-tips {
    font-size: 12px;
    color: #909399;
    margin-top: 8px;
    margin-left: 4px;
  }

  .password-form {
    .el-form-item {
      margin-bottom: 20px;

      &:last-child {
        margin-bottom: 0;
      }
    }
  }
}

/* 动画 */
@keyframes slideDown {
  from {
    opacity: 0;
    transform: translateY(-20px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

@keyframes slideUp {
  from {
    opacity: 0;
    transform: translateY(20px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

/* 响应式调整 */
@media (max-width: 360px) {
  .content-layer {
    padding: 15px;
    padding-top: 50px;
  }

  .user-card {
    padding: 20px 16px;

    .user-avatar .avatar-img {
      width: 70px;
      height: 70px;
    }

    .user-info .user-name {
      font-size: 20px;
    }
  }

  .settings-item,
  .logout-item {
    padding: 16px;
  }
}

@media (min-width: 768px) {
  .content-layer {
    max-width: 500px;
    margin: 0 auto;
  }
}
</style>

<style lang="scss">
/* 全局弹窗样式 */
.custom-dialog {
  border-radius: 20px !important;
  overflow: hidden;

  .el-dialog__header {
    background: white;
    padding: 24px 24px 20px;
    border-bottom: 1px solid #f0f0f0;

    .el-dialog__title {
      color: #303133;
      font-weight: 600;
      font-size: 18px;
    }

    .el-dialog__headerbtn {
      top: 24px;
      right: 24px;

      .el-dialog__close {
        color: #909399;
        font-size: 20px;

        &:hover {
          color: #ff813d;
        }
      }
    }
  }

  .el-dialog__body {
    padding: 30px 24px;
  }

  .el-dialog__footer {
    padding: 20px 24px 30px;
    text-align: center;

    .el-button {
      min-width: 80px;
      border-radius: 8px;
      padding: 10px 20px;
      font-weight: 500;

      &--default {
        color: #606266;
        border-color: #dcdfe6;

        &:hover {
          color: #ff813d;
          border-color: #ff813d;
        }
      }

      &--primary {
        background: linear-gradient(135deg, #ff813d, #ffb347);
        border: none;

        &:hover {
          opacity: 0.9;
          background: linear-gradient(135deg, #ff813d, #ffb347);
        }

        &[disabled] {
          background: #c0c4cc;
          opacity: 0.6;
        }
      }
    }
  }
}

/* 退出确认框样式 */
.logout-confirm {
  .el-message-box__header {
    background: white;
    padding: 20px 20px 15px;
    border-bottom: 1px solid #f0f0f0;

    .el-message-box__title {
      color: #303133;
      font-weight: 600;
    }

    .el-message-box__headerbtn {
      top: 20px;

      .el-message-box__close {
        color: #909399;

        &:hover {
          color: #ff4757;
        }
      }
    }
  }

  .el-message-box__content {
    padding: 30px 20px;
  }

  .el-message-box__btns {
    padding: 20px 20px 30px;
    text-align: center;

    .el-button {
      min-width: 80px;
      border-radius: 8px;
      padding: 10px 20px;
      font-weight: 500;

      &--default {
        color: #606266;
        border-color: #dcdfe6;

        &:hover {
          color: #ff813d;
          border-color: #ff813d;
        }
      }

      &--primary {
        background: linear-gradient(135deg, #ff4757, #ff6b6b);
        border: none;

        &:hover {
          opacity: 0.9;
          background: linear-gradient(135deg, #ff4757, #ff6b6b);
        }
      }
    }
  }
}
</style>
